import React, { useState, useEffect } from "react";
import "./Header.css";
import logoImage from '../assets/logo.png';
const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState("features");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`header ${scrolled ? "scrolled" : ""}`}>
      <div className="header-container">

        {/* Logo */}
        <div className="logo-area">
          <a href="/">
    <img src={logoImage} alt="DrivyPal Solutions" className="logo-image" />
  </a>
        </div>

        {/* Navigation */}
        <nav className={`nav ${menuOpen ? "active" : ""}`}>
          {["Home","Services", "About", "contact"].map((item) => (
            <a
              key={item}
              href={`#${item}`}
              className={active === item ? "active-link" : ""}
              onClick={() => {
                setActive(item);
                setMenuOpen(false);
              }}
            >
              {item === "contact" ? "Contact Us" : item.charAt(0).toUpperCase() + item.slice(1)}
              <span className="underline"></span>
            </a>
          ))}
        </nav>

        {/* Mobile Toggle */}
        <div
          className={`menu-toggle ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

      </div>
    </header>
  );
};

export default Header;
